import { IconBaseProps } from "react-icons";

export function AssignUserIcon(props: IconBaseProps) {
  const { size = 24, color = "currentColor", ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_3903_14135)">
        <path
          d="M11.9931 11.4472C14.5005 11.4472 16.5331 9.41456 16.5331 6.90719C16.5331 4.39981 14.5005 2.36719 11.9931 2.36719C9.48575 2.36719 7.45312 4.39981 7.45312 6.90719C7.45312 9.41456 9.48575 11.4472 11.9931 11.4472Z"
          fill={color}
        />
        <path
          d="M7.9999 17.7667C8.01376 17.3979 8.13666 17.0414 8.35308 16.7424C8.56949 16.4433 8.8697 16.2152 9.21576 16.0868C9.56182 15.9583 9.93818 15.9354 10.2973 16.0208C10.6564 16.1062 10.9821 16.2962 11.2332 16.5667L13.8066 19.3334L18.3666 14.2467C16.4831 12.9911 14.2633 12.3356 11.9999 12.3667C10.4298 12.327 8.8701 12.6317 7.4304 13.2594C5.9907 13.8872 4.70598 14.8226 3.66657 16.0001C3.57864 16.1173 3.53178 16.2602 3.53324 16.4067V20.0001C3.53308 20.3468 3.66805 20.6801 3.90951 20.929C4.15098 21.1779 4.47993 21.323 4.82657 21.3334H10.5399L8.49324 19.1334C8.32382 18.9501 8.19287 18.7348 8.10814 18.5C8.0234 18.2653 7.9866 18.0159 7.9999 17.7667Z"
          fill={color}
        />
        <path
          d="M19.1735 21.3341C19.5202 21.3237 19.8491 21.1787 20.0906 20.9298C20.3321 20.6808 20.467 20.3476 20.4669 20.0008V17.4941L17.0469 21.3341H19.1735Z"
          fill={color}
        />
        <path
          d="M22.514 12.4142C22.4486 12.3551 22.3721 12.3095 22.2889 12.2802C22.2057 12.2508 22.1176 12.2383 22.0295 12.2432C21.9415 12.2482 21.8553 12.2706 21.776 12.3091C21.6966 12.3476 21.6257 12.4015 21.5673 12.4676L13.8207 21.1342L10.354 17.4076C10.2971 17.341 10.2276 17.2863 10.1496 17.2466C10.0716 17.2069 9.98647 17.183 9.89918 17.1762C9.8119 17.1694 9.72412 17.1798 9.64087 17.2069C9.55762 17.2341 9.48053 17.2773 9.414 17.3342C9.35151 17.3962 9.30191 17.4699 9.26807 17.5512C9.23422 17.6324 9.2168 17.7195 9.2168 17.8076C9.2168 17.8956 9.23422 17.9827 9.26807 18.0639C9.30191 18.1452 9.35151 18.2189 9.414 18.2809L13.8673 23.0809L22.5607 13.3342C22.6728 13.2043 22.7305 13.0362 22.7218 12.8649C22.7131 12.6935 22.6387 12.5321 22.514 12.4142Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3903_14135">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
